import { apiWrapper } from "@/services/api";
import store from "@/store/index";

export const postBookingOrPurchase = async (params) => {
  let response;
  try {
    response = await apiWrapper(
      "POST",
      `/mfitt/sbps/limited_express_tickets`,
      params
    );
    console.log("postBookingOrPurchase response.data :>> ", response.data);
    // 購入完了画面で使用するため、response.dataをstoreに格納
    store.commit("MFITT/setMyLimitedExpressTicket", response.data);
  } catch (err) {
    console.log('ERROR"" postBookingOrPurchase():', err);
    throw err;
  }
  return response.data;
};
